import { ReactNode, useCallback, useState } from 'react';
import { ColorMode, ColorModeContext } from '@/contexts/colorModeContext.ts';

const STORAGE_KEY = 'manager-social-garden-color-mode';

interface ColorModeProviderProps {
  children?: ReactNode;
}

export default function ColorModeProvider({
  children,
}: ColorModeProviderProps) {
  const [mode, setMode] = useState<ColorMode>(() => {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'light') {
      return 'light';
    }
    if (value === 'dark') {
      return 'dark';
    }
    return 'system';
  });

  const set = useCallback((value: ColorMode) => {
    localStorage.setItem(STORAGE_KEY, value);
    setMode(value);
  }, []);

  return (
    <ColorModeContext.Provider
      value={{
        mode,
        setMode: set,
      }}>
      {children}
    </ColorModeContext.Provider>
  );
}
